module.exports = __webpack_public_path__ + "img/842098d.jpg";